export default __webpack_public_path__ + "static/media/madame_detail3.aa29e65c.jpg";